import React from "react-router-dom";
import  Home  from "./components/Home";
import './App.css'; 

function App(){
  return(
    <div className='app'>
       <Home></Home>
    </div>
  ) 
}

export default App;
